import { Box } from '@zillow/constellation-10';

import AddAmenitiesFormField from '../AddAmenities/AddAmenitiesFormField';
import AmenitiesPropertyFormField from '../AmenitiesPropertyFormField';

type Props = {
  isRelistingFieldset?: boolean;
  additionalAmenitiesTopSpacing?: boolean;
};

const AmenitiesWithAdditionalAmenitiesFields = ({
  isRelistingFieldset,
  additionalAmenitiesTopSpacing = false,
}: Props) => {
  return (
    <div data-testid="AmenitiesWithAdditionalAmenitiesFields">
      <AmenitiesPropertyFormField isRelistingFieldset={isRelistingFieldset} />
      <Box css={additionalAmenitiesTopSpacing ? { marginTop: '400' } : undefined}>
        <AddAmenitiesFormField isRelistingFieldset={isRelistingFieldset} />
      </Box>
    </div>
  );
};

export default AmenitiesWithAdditionalAmenitiesFields;
